module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av589-9366ab97eccb3974e1454b77734eb6f2.jpg";